import type { ProductService } from '@/types/order.types';

/**
 * The all-in price to charge for a single unit (one photo) of a service.
 *
 * Backend pricing (product-service `ProductServiceImpl#updatePricingMap`) splits
 * a service's cost across `basePrice` + `unitPrice * quantity`, and exposes the
 * summed result as `totalPrice`. A flat-priced service therefore has
 * `unitPrice == 0` with the whole cost in `basePrice`/`totalPrice` — so reading
 * `unitPrice` alone reports such services as free. `totalPrice` is the field to
 * read (this mirrors the service-selection `serviceHelpers` and the carousel
 * badge price, which both use the quantity-1 `totalPrice`).
 *
 * Prefer the quantity-1 entry from the pricing `map`; fall back to
 * `defaultPricing` (which the backend sets to the quantity-1 pricing, and which
 * is the only source for "no valid quantities" services where `map` is empty).
 */
export const getServiceUnitPrice = (service: ProductService): number =>
  service.map?.[1]?.totalPrice ?? service.defaultPricing?.totalPrice ?? 0;
